import axios from "axios";
import { getCurrentStoreData } from "../websites/thunks";
import { api } from "../../data/urls";
import { getCurrentWebsiteSubdomain } from "../../helpers/getCurrentWebsiteSubdomain";
import returnAuthHeaderForAJAX from "../../helpers/auth/returnAuthHeaderForAJAX";
import {
  websiteCustomCodeUpdateWaitingForServer,
  websiteExtraCustomCodeUpdateWaitingForServer,
} from "../websites/actions";

interface Data {
  script: string;
  location: string;
  placement?: string;
}
export const handleOnAddScriptMessage = (
  { script, location, placement }: Data,
  saveWebsiteDataInStore: any
) => {
  return (dispatch, getState) => {
    const waitingForServerFunctionsMap = {
      global_head_html: (val) => {
        dispatch(websiteCustomCodeUpdateWaitingForServer(val));
      },
      global_body_html: (val) => {
        dispatch(websiteExtraCustomCodeUpdateWaitingForServer(val));
      },
    };
    const { currentWebsite } = dispatch(getCurrentStoreData());
    const websites = getState().websites;
    const accessToken = getState().auth.accessToken;
    if (!currentWebsite) {
      return;
    }
    let result = currentWebsite[location];
    if (placement === "before") {
      result = script + "\n\n" + result;
    } else {
      result = result + "\n\n" + script;
    }
    const dataToStore = {
      data: {
        ...currentWebsite,
        [location]: (result || "").toString().trim(),
      },
    };
    saveWebsiteDataInStore(dataToStore, currentWebsite.subdomain);
    let apiUrl =
      api.websites.updateWebsite.prefix +
      getCurrentWebsiteSubdomain(websites.items) +
      api.websites.updateWebsite.postfix;
    waitingForServerFunctionsMap[location](true);
    axios
      .patch(
        apiUrl,
        { [location]: result },
        { ...returnAuthHeaderForAJAX(accessToken) }
      )
      .then(() => {
        waitingForServerFunctionsMap[location](false);
      })
      .catch((error) => {
        waitingForServerFunctionsMap[location](false);
        console.error(error);
      });
  };
};
